import { Skeleton } from 'antd';
import { Column, Row, Space } from 'farmhub-ui-core';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 78px;
  border: 1px solid ${props => props.theme.colors.border.main};
  border-radius: ${props => props.theme.radius.lg};
  padding: ${p => p.theme.app.padding.vertical}
    ${p => p.theme.app.padding.horizontal};
  justify-content: space-between;
  margin-bottom: 14px;
`;

const InfoCard = styled.div`
  display: flex;
  width: fit-content;
`;

const Img = styled.div`
  width: 55px;
  height: 42px;

  box-sizing: border-box;
  border-radius: 50%;
`;

const EntityCardSkeletonDesktop = () => (
  <Wrapper>
    <Row justifyContent="space-between">
      <InfoCard style={{ alignItems: 'center' }}>
        <Img>
          <Skeleton.Avatar size="large" />
        </Img>
        <Column>
          <Skeleton.Input size="small" style={{ width: 200 }} />
          <Space height={2} />
          <Skeleton.Input size="small" style={{ width: 300 }} />
        </Column>
      </InfoCard>
      <Row styles={{ gap: 6, flexDirection: 'column' }} width="fit-content">
        <Row>
          <Skeleton.Input
            size="small"
            style={{ width: 16, height: 16, borderRadius: '50%' }}
          />
          <Skeleton.Input
            size="small"
            style={{ width: 16, height: 16, borderRadius: '50%' }}
          />
          <Skeleton.Input
            size="small"
            style={{ width: 16, height: 16, borderRadius: '50%' }}
          />
        </Row>
        <Skeleton.Input size="small" style={{ width: 80, height: 16 }} />
      </Row>
    </Row>
  </Wrapper>
);

export default EntityCardSkeletonDesktop;
